import { useAuth } from './lib/auth';
import SignIn from './pages/SignIn';
import Dashboard from './pages/Dashboard';
import SigningApp from './signing/SigningApp';
import DownloadPage from './signing/DownloadPage';

/**
 * Two entirely separate surfaces share this bundle.
 *
 * The signing route is matched FIRST and never touches the auth context:
 * signers hold no Firebase credential, and showing them a sign-in screen — even
 * briefly — would be both confusing and wrong.
 */
export default function App() {
  const path = window.location.pathname;

  const signing = /^\/s\/([A-Za-z0-9_-]{20,})$/.exec(path);
  if (signing) return <SigningApp token={signing[1]!} />;

  const download = /^\/d\/([A-Za-z0-9_-]{20,})$/.exec(path);
  if (download) return <DownloadPage token={download[1]!} />;

  return <OwnerApp />;
}

function OwnerApp() {
  const { user, loading } = useAuth();
  if (loading) return <main className="center"><p className="muted">Loading…</p></main>;
  return user ? <Dashboard /> : <SignIn />;
}
